module.exports = __webpack_public_path__ + "static/media/mappinPopup.a7448bf7.svg";